import { armSportsnewMembershipQuarantineReopen, createSportsnewMembershipQuarantine } from '../_helpers/sportsnewMembershipQuarantine';
import { failCloseSportsnewFixtureListOdds } from '../_helpers/sportsnewListPatch';
import { useCallback } from 'react';

// Owns membership quarantine within the existing split context.
// Provider refs retain account/list/detail authority; callers receive stable actions.
export const useSportsnewMembershipQuarantine = ({
  displayScopeRef, listFilterKeyRef, listMembershipRevisionRef, membershipFailClosedFixturesRef,
  modeRef, selectionsRef, updateOddsInCart,
}) => {
  const failCloseCartSelectionsForFixtures = useCallback((fixtureIds = []) => {
      const targets = new Set((Array.isArray(fixtureIds) ? fixtureIds : [fixtureIds])
        .filter(value => value != null)
        .map(String));
      if (targets.size === 0) return;
      selectionsRef.current.forEach((selection) => {
        const selectionFixtureId = selection?.match_id
          ?? selection?.matchId
          ?? selection?.fixtureId
          ?? selection?.fixture_id;
        if (selectionFixtureId == null || !targets.has(String(selectionFixtureId))) return;
        updateOddsInCart?.(selection.odds_id, null, {
          bettable: false,
          locked: true,
          is_suspended: true,
          reason: 'MEMBERSHIP_REFRESH_PENDING',
        });
      });
    }, [selectionsRef, updateOddsInCart]);

  const quarantineMembershipFixtures = useCallback((fixtureIds = []) => {
      const originRequestKey = listFilterKeyRef.current;
      const baselineRevision = listMembershipRevisionRef.current;
      const quarantined = [];
      (Array.isArray(fixtureIds) ? fixtureIds : [fixtureIds]).forEach((value) => {
        if (value == null) return;
        const id = String(value);
        membershipFailClosedFixturesRef.current.set(id, createSportsnewMembershipQuarantine({
          requestKey: originRequestKey,
          baselineRevision,
          mode: modeRef.current,
          scope: displayScopeRef.current,
        }));
        quarantined.push(id);
      });
      failCloseCartSelectionsForFixtures(quarantined);
      return quarantined;
    }, [
    displayScopeRef, failCloseCartSelectionsForFixtures, listFilterKeyRef, listMembershipRevisionRef,
    membershipFailClosedFixturesRef, modeRef,
  ]);

  const armMembershipQuarantineReopen = useCallback((fixtureIds = []) => {
      const requestKey = listFilterKeyRef.current;
      const baselineRevision = listMembershipRevisionRef.current;
      (Array.isArray(fixtureIds) ? fixtureIds : [fixtureIds]).forEach((value) => {
        if (value == null) return;
        const id = String(value);
        const quarantine = membershipFailClosedFixturesRef.current.get(id);
        if (!quarantine) return;
        membershipFailClosedFixturesRef.current.set(id, armSportsnewMembershipQuarantineReopen(
          quarantine,
          {
            requestKey,
            baselineRevision,
            mode: modeRef.current,
            scope: displayScopeRef.current,
          },
        ));
      });
    }, [
    displayScopeRef, listFilterKeyRef, listMembershipRevisionRef, membershipFailClosedFixturesRef,
    modeRef,
  ]);

  const failCloseQuarantinedFixtures = useCallback((rows) => (
      failCloseSportsnewFixtureListOdds(
        rows,
        [...membershipFailClosedFixturesRef.current.keys()],
      )
    ), [membershipFailClosedFixturesRef]);

  return { failCloseCartSelectionsForFixtures, quarantineMembershipFixtures, armMembershipQuarantineReopen, failCloseQuarantinedFixtures };
};
